// TransactionDetailsDialog.js
import { CircularProgress } from '@mui/material';
import CustomDialog from 'widgets/component/CustomDialog';
import DataTableDetailOrder from 'widgets/customDialogComponentDetails/ComponentDialog';
import { CircularProgressStyle } from '../style/style';

const TransactionDetailsYuno = ({
  open,
  onClose,
  loading,
  detailTransactionsYuno,
  handleOpenPopUp,
  setOpenActionFraud,
  setIdReverso,
  setActiveAction,
  setShouldReturnData,
  activeAction,
  shouldReturnData,
}) => (
  <CustomDialog
    fullWidth
    title={
      detailTransactionsYuno?.response?.result?.payment_info === null
        ? 'No hay datos'
        : 'Transacción Yuno'
    }
    content={
      loading ? (
        <CircularProgress sx={CircularProgressStyle.CircularProgress} />
      ) : (
        <DataTableDetailOrder
          type='detailsYuno'
          handleOpenPopUp={handleOpenPopUp}
          setOpenActionFraud={setOpenActionFraud}
          response={detailTransactionsYuno?.response?.result}
          idTransaction={detailTransactionsYuno?.response?.result?.transaction_type?.transaction_id}
          onClose={onClose}
          setIdReverso={setIdReverso}
          setActiveAction={setActiveAction}
          setShouldReturnData={setShouldReturnData}
          activeAction={activeAction}
          shouldReturnData={shouldReturnData}
        />
      )
    }
    open={open}
    onClose={onClose}
    maxWidth='md'
    extraButtons={[
      {
        label: 'Aceptar',
        variant: 'contained',
        onClick: onClose,
        buttonColor: 'purple',
        textColor: 'white',
      },
    ]}
  />
);

export default TransactionDetailsYuno;
